import PropTypes from 'prop-types'
import { BranchMixin } from 'legacy/libs/baobab-react-mixins'
import BaobabPropTypes from 'legacy/libs/baobab-prop-types'

import createReactClass from 'create-react-class'

export default createReactClass({
  displayName: 'Tab',

  mixins: [BranchMixin],

  propTypes: {
    name: PropTypes.string.isRequired,
    children: PropTypes.node,
    cursor: BaobabPropTypes.cursor,
  },

  cursors(props) {
    return {
      current: this.props.cursor,
    }
  },

  render() {
    if (this.props.name !== this.state.current) {
      return null
    }

    return this.props.children
  },
})
